export const setupReact18EventBridge = (rootElement) => {
    const listenerMap = new Map();
    const originalAddEventListener = rootElement.addEventListener.bind(rootElement);
    const originalRemoveEventListener = rootElement.removeEventListener.bind(rootElement);
    rootElement.addEventListener = (type, listener, options) => {
        originalAddEventListener(type, listener, options);
        if (typeof listener === "function") {
            const documentWrapper = (event) => {
                const target = event.target;
                if (target && !rootElement.contains(target)) {
                    listener.call(rootElement, event);
                }
            };
            listenerMap.set(listener, { documentWrapper, options });
            document.addEventListener(type, documentWrapper, options);
        }
    };
    rootElement.removeEventListener = (type, listener, options) => {
        originalRemoveEventListener(type, listener, options);
        if (typeof listener === "function") {
            const entry = listenerMap.get(listener);
            if (entry) {
                document.removeEventListener(type, entry.documentWrapper, options);
                listenerMap.delete(listener);
            }
        }
    };
};
